import React from "react";
import { makeStyles } from "@mui/styles";
import DialogContent from "@mui/material/DialogContent";

const useStyles = makeStyles(() => ({
  root: {
    padding: 0,
  },
}));

const ModalCompactBody = ({ children, customClass, ...rest }) => {
  const classes = useStyles();

  return (
    <DialogContent classes={{ root: classes.root }} className={customClass} {...rest}>
      {children}
    </DialogContent>
  );
};

export default ModalCompactBody;
